/**
 * Created by cghislai on 03/08/16.
 */

import {Pipe, PipeTransform} from '@angular/core';
import {NumberUtils} from '../util/numberUtils';

@Pipe({name: 'cCurrency'})
export class CurrencyPipe implements PipeTransform {

  transform(value: number | string, ...args: any[]) {
    const allowStrings = args.find(a => a === 'allowStrings') != null;
    let numberValue = value;
    if (typeof value === 'string') {
      numberValue = parseFloat(value);
    }
    const formatted = NumberUtils.formatCurrency(numberValue);
    if (formatted) {
      return formatted;
    } else if (allowStrings && typeof value === 'string') {
      return value;
    } else {
      return null;
    }
  }

}
